import { noddiToast } from './toast';

export const copyToClipboardWithToast = async (text: string, label?: string) => {
  if (!text) {
    noddiToast.error(label ? `No ${label.toLowerCase()} to copy` : 'Nothing to copy');
    return;
  }
  try {
    await navigator.clipboard.writeText(text);
    noddiToast.success(label ? `${label} copied to clipboard` : 'Copied to clipboard');
  } catch {
    noddiToast.error(label ? `Failed to copy ${label.toLowerCase()}` : 'Failed to copy to clipboard');
  }
};
